import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

export function BrandMark({ variant }) {
  const mode = variant || 'default';
  const isSidebar = mode === 'sidebar';

  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.96 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.25 }}
      className={isSidebar ? 'brand-block brand-block-sidebar' : 'brand-block'}
    >
      <Link to="/platforms" className="brand-home-link brand-home-link-wordmark" aria-label="HK ID — go to Platforms">
        <motion.img
          whileHover={{ scale: isSidebar ? 1.03 : 1.04 }}
          whileTap={{ scale: isSidebar ? 0.98 : 0.97 }}
          className={isSidebar ? 'brand-wordmark brand-wordmark-sidebar' : 'brand-wordmark'}
          src="/hk-id-logo.png"
          alt="HK ID"
        />
      </Link>
    </motion.div>
  );
}
